"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTabsterAttributes", {
    enumerable: true,
    get: function() {
        return useTabsterAttributes;
    }
});
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
const useTabsterAttributes = (props)=>{
    // A tabster instance is not necessary to generate tabster attributes
    // but calling the hook will ensure that a tabster instance exists internally and avoids consumers doing the same
    (0, _useTabster.useTabster)();
    return (0, _tabster.getTabsterAttribute)(props);
};
